<template>
<div class="px-5 py-2 mb-12">
  <div v-if="allowedComponents.includes('Merchants')">

    <v-card max-width="800px" flat>
      <div>
        <v-layout row>
          <v-text-field
              label="Search"
              @input="onSearch"
              style="margin-bottom: 10px; padding: 10px"
              single-line
              hide-details
              append-icon="mdi-account-search"
              maxlength="125"
          ></v-text-field>
        </v-layout>
      </div>
    </v-card>

<!--    Merchants display table-->
    <v-data-table
        :headers="headers"
        :items="merchants"
        :loading="isLoading"
        :options="options"
        @update:options="onOptionsChange"
        @click:row="onRowClick"
        :server-items-length="totalItems"
        :items-per-page="options.itemsPerPage"
        :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        class="mt-2"
    >

      <template v-slot:no-data>
        <div v-if="isLoading">
          <v-progress-linear class="my-4" indeterminate />
        </div>
        <v-alert v-else type="info" border="left" colored-border :icon="false">
          No merchants found.
        </v-alert>
      </template>
    </v-data-table>

<!--    Selected merchant display/removal-->
    <selected-merchant v-if="showMerchant"
                       @on-close="showMerchant = false"
                       @removed-successfully="successfulMerchantRemoval"
                       :merchant="selectedMerchant"/>

    <ErrorDialog ref="errorDialog"/>
    <SnackBar ref="snackbar"/>
  </div>
  <div v-else class="pl-12 pr-12 pt-12 mt-12 headline text-center">Sorry, this page is not available.</div>
</div>
</template>

<script>
// @ is an alias to /src
import ErrorDialog from "@/components/ErrorDialog";
import SelectedMerchant from "@/views/SelectedMerchant.vue";
import SnackBar from "@/components/Snackbar.vue";

export default {
  name: 'MerchantsTable',
  components: {SnackBar, ErrorDialog, SelectedMerchant },
  data() {
    return {
      selectedMerchantDialog: false,
      allowedComponents: JSON.parse(localStorage.getItem('allowedComponents') || ''),
      search: '',
      merchants: [],
      totalItems: 0,
      isLoading: true,
      showMerchant: false,
      debounceTimeout: null,
      selectedMerchant: {},
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['business_name'],
        sortDesc: [false]
      },
      headers: [
        { text: 'Business Name', value: 'business_name', align: 'start', sortable: true },
        { text: 'Business Email', value: 'business_email', align: 'start', sortable: true },
        { text: 'Username', value: 'username', align: 'start', sortable: true },
        { text: 'Approved Time', value: 'approved_time', align: 'end', sortable: true },
        { text: 'Verified', value: 'verified', align: 'end', sortable: true }
      ]
    };
  },

  mounted() {
    localStorage.title = 'Merchants';
    this.getMerchants();
  },

  methods: {
    onOptionsChange(newOptions) {
      this.options = newOptions;
      this.debouncedGetMerchants();
    },
    async onRowClick(merchant) {
      const merchantUuid = merchant.merchant_uuid
      try {
        const response = await this.axios.get('merchant/' + merchantUuid)
        this.selectedMerchant = response.data;
        this.selectedMerchant.uuid = merchantUuid;
        this.showMerchant = true;
      } catch (e) {
        let errorInfo = ' ';
        if (e.response && e.response.data && e.response.data.message) {
          errorInfo = " " + e.response.data.message;
        }
        this.$refs.errorDialog.showError({
          errorMessage: "Failed to get Merchant.",
          forDevelopers: e + errorInfo
        });
      }

    },
    onSearch(val) {
      this.search = val;
      this.options.page = 1;
      this.debouncedGetMerchants();
    },

    successfulMerchantRemoval() {
      this.debouncedGetMerchants();
      this.$refs.snackbar.showSnackbar({
        text: "The merchant was successfully removed!",
        color: "success"
      });
    },

    debouncedGetMerchants() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.getMerchants();
      }, 400);
    },

    async getMerchants() {
      this.isLoading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        try {
          const response = await this.axios.get('/admin/merchant/view', {
            params: {
              page,
              perPage: itemsPerPage,
              sortBy: sortBy[0] || '',
              sortDesc: sortDesc[0] || false,
              search: this.search || ''
            }
          });

        this.merchants = response.data.data;
        this.totalItems = response.data.total;
      } catch (e) {
        let errorInfo = ' ';
        if (e.response && e.response.data && e.response.data.message) {
          errorInfo = " " + e.response.data.message;
        }
        this.$refs.errorDialog.showError({
          errorMessage: "Failed to get Merchants.",
          forDevelopers: e + errorInfo
        });
        this.merchants = [];
        this.totalItems = 0;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
</style>